import { createFileRoute, redirect } from "@tanstack/react-router";

/** Demo used synthetic diaries - live builder is at /analytics. */
export const Route = createFileRoute("/_app/design/features/generalised-analytics")({
    beforeLoad: () => {
        throw redirect({ to: "/analytics" });
    },
});
